import React from 'react';

import db from 'service/db'
import { useSelector } from 'react-redux'

import { Table, Pagination } from 'react-bootstrap';
import UpdateModal from './ImageBoard/UpdateModal';

function ImageBoard() {
    // let id = useSelector(state => state.userInfo.id);
    const [dataList, setDataList] = React.useState([])

    const [page, setPage] = React.useState(1);

    function CustomPage() {
        let len = parseInt((dataList.length - 1) / 10) + 1;
        let start = parseInt(page / 10) + 1;
        let end = (parseInt((start - 1) / 10) + 1) * 10
        console.log(len, end)
        end = end > len ? len : end;
        let elements = []
        for (let i = start; i <= end; i++) {

            if (i === page)
                elements.push(<Pagination.Item active >{i}</Pagination.Item>)
            else
                elements.push(<Pagination.Item onClick={() => { setPage(i) }}>{i}</Pagination.Item>)
        }


        return elements;
    }

    React.useEffect(() => {
        Promise.all([
            db.getImagesByCategory('main'),
            db.getImagesByCategory('sub')
        ]).then(items => {
            console.log([...items[0], ...items[1]])
            setDataList([...items[0], ...items[1]])
        })
    }, [])

    function Rendering() {
        return <>
            <Table>
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Image</th>
                        <th>Link</th>
                        <th>Category</th>
                        <th>Update</th>
                    </tr>
                </thead>
                <tbody>
                    {dataList.filter((item, idx) => idx >= (page - 1) * 10 && idx < page * 10).map(item => {
                        return <tr key={item.id}>
                            <td>{item.id}</td>
                            <td><img src={item.src} height={120} alt="사진" /></td>
                            <td>{item.link}</td>
                            <td>{item.category}</td>
                            <td><UpdateModal data={item} btnTitle="Update" /></td>
                        </tr>
                    })}
                </tbody>
            </Table>
        </>
    }

    return (
        <div className="container">
            <div className="d-flex justify-content-between align-items-end my-3">
                <h3>
                    메인 이미지 관리
                </h3>
                <UpdateModal btnTitle="Add" />
            </div>
            <Rendering />
            <div>
                <Pagination className="justify-content-center">
                    <Pagination.First onClick={() => { setPage(1) }} />
                    <Pagination.Prev onClick={() => { setPage(page === 1 ? page : page - 1) }} />
                    <CustomPage />
                    <Pagination.Next onClick={() => { setPage(page === parseInt(dataList.length / 10) + 1 ? page : page + 1) }} />
                    <Pagination.Last onClick={() => { setPage(parseInt(dataList.length / 10) + 1) }} />
                </Pagination>
            </div>
        </div>
    );
}

export default ImageBoard;